export const getFetchOptions = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const optionsString = urlParams.get("options");
  if (!optionsString)
    throw new Error("No options object specified");
  const options = JSON.parse(optionsString);
  const {urlTemplate, vars, varsA, varsB, headers, headersA, headersB} = options;
  if (!urlTemplate || typeof urlTemplate !== "string") {
    throw new Error("No request URL supplied");
  }
  const optionsA = {
    urlTemplate,
    vars: {...vars, ...varsA},
    headers: {...headers, ...headersA}
  };
  const optionsB = {
    urlTemplate,
    vars: {...vars, ...varsB},
    headers: {...headers, ...headersB}
  };
  return [optionsA, optionsB];
};
